import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Contact from './components/Contact';
import Team from './components/Team';
import Splash from './components/Splash';
import ScrollToTop from './ScrollToTop';

import ITAndCyberLaw from './DescriptionPage/ITAndCyberLaw';
import CriminalLaw from './DescriptionPage/CriminalLaw';
import MatrimonialDisputes from './DescriptionPage/MatrimonialDisputes';
import TaxationLaw from './DescriptionPage/TaxationLaw';
import ConsumerProtectionLaw from './DescriptionPage/ConsumerProtectionLaw';
import ArbitrationLaw from './DescriptionPage/ArbitrationLaw';
import CorporateCommercialLaw from './DescriptionPage/CorporateCommercialLaw';
import IndustrialLabourAndEmployment from './DescriptionPage/IndustrialLabourAndEmployment';
import IntellectualPropertyLaw from './DescriptionPage/IntellectualPropertyLaw';
import StatutoryAndGovernmentApprovals from './DescriptionPage/StatutoryAndGovernmentApprovals';
import RealEstateLaw from './DescriptionPage/RealEstateLaw';

import './App.css';

function App() {
  const [isSplashFinished, setIsSplashFinished] = useState(false);
  const [isDisclaimerVisible, setIsDisclaimerVisible] = useState(false);

  useEffect(() => {
    // Show splash screen for 4.8 seconds
    const splashTimer = setTimeout(() => {
      setIsSplashFinished(true);
      if (sessionStorage.getItem('disclaimerAccepted') !== 'true') {
        setIsDisclaimerVisible(true); // Show disclaimer if not accepted
      }
    }, 4800);

    return () => clearTimeout(splashTimer); // Cleanup timer
  }, []);

  const handleAcceptDisclaimer = () => {
    sessionStorage.setItem('disclaimerAccepted', 'true');
    setIsDisclaimerVisible(false);
  };

  // Show splash screen first
  if (!isSplashFinished) {
    return <Splash />;
  }

  return (
    <Router>
       <ScrollToTop />
      <div className="App">
        <Routes>
        <Route path="/" element={<Home />} />
           <Route path="/contact" element={<Contact />} />
           <Route path="/team" element={<Team />} />
           <Route path="/ArbitrationLaw" element={<ArbitrationLaw />} />
           <Route path="/ConsumerProtectionLaw" element={<ConsumerProtectionLaw />} />
           <Route path="/CorporateCommercialLaw" element={<CorporateCommercialLaw />} />
           <Route path="/CriminalLaw" element={<CriminalLaw />} />
           <Route path="/IndustrialLabourAndEmployment" element={<IndustrialLabourAndEmployment />} />
           <Route path="/IntellectualPropertyLaw" element={<IntellectualPropertyLaw />} />
           <Route path="/ITAndCyberLaw" element={<ITAndCyberLaw />} />
           <Route path="/MatrimonialDisputes" element={<MatrimonialDisputes />} />
           <Route path="/RealEstateLaw" element={<RealEstateLaw />} />
           <Route path="/StatutoryAndGovernmentApprovals" element={<StatutoryAndGovernmentApprovals />} />
           <Route path="/TaxationLaw" element={<TaxationLaw />} />
           <Route path="*" element={<Navigate to="/" />} />

        </Routes>

        {/* Disclaimer Modal */}
        {isDisclaimerVisible && (
          <div className="disclaimer-modal">
            <div className="disclaimer-content">
              <h1 className="disclaimer-h1">DISCLAIMER</h1>
              <p>
                The Bar Council of India does not permit advertisement or solicitation by advocates
                in any form or manner. By accessing this website, you
                acknowledge and confirm that you are seeking information relating to LegalTrails of
                your own accord and that there has been no form of solicitation, advertisement, or
                inducement by LegalTrails or its members. The content of this website is for
                informational purposes only and should not be interpreted as soliciting or
                advertisement. No material/information provided on this website should be construed
                as legal advice. LegalTrails shall not be liable for consequences of any action
                taken by relying on the material/information provided on this website.
              </p>
              <button onClick={handleAcceptDisclaimer} className="btn btn-primary">
                I Agree
              </button>
            </div>
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;




